import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import messages from '../invoicingMessages';

const RegistrationRemarkTooltip = ({ remark, internalRemark, intl }) => (
  <div id="popover-trigger-hover-focus">
    {!!remark && (
      <div title={intl.formatMessage(messages.Remark)}>
        <span style={{ whiteSpace: 'pre-line' }}>{remark}</span>
      </div>
    )}
    {!!internalRemark && (
      <div title={intl.formatMessage(messages.InternalRemark)}>
        <span style={{ whiteSpace: 'pre-line', fontStyle: 'italic' }}>{internalRemark}</span>
      </div>
    )}
  </div>
);
RegistrationRemarkTooltip.propTypes = {
  remark: PropTypes.string,
  internalRemark: PropTypes.string,
  intl: intlShape.isRequired,
};
RegistrationRemarkTooltip.defaultProps = {
  remark: null,
  internalRemark: null,
};

export default injectIntl(RegistrationRemarkTooltip);
